export default __webpack_public_path__ + "static/2.3-1cdd1e7cde131e931e7874978ed61964.webp";